<template>
    <div class="row">
      <div class="col-sm-12 card m-0 p-0 mb-5">
        <div class="card-header pt-3 pb-3">
            <v-form ref="form" v-model="valid" lazy-validation>
                <div class="row m-1">
                    <div class="col-xl-6 col-lg-6 col-12">
                        <div class="input-group input-group-sm">
                                <span class="input-group-addon mb-1" style="min-width: 9em;">{{
                                    $t('alarmSetting.device')
                                }}</span>
                        </div>
                        <div class="input-group-append">
                            <v-select :items="deviceList" v-model="modelSearch.DeviceCode" dense outlined
                                item-value="code"
                                v-on:change="handleSelectDevice">
                                <template v-slot:[`item`]="{ item }">
                                    <span :key="item.code" :value="item.code">{{ $i18n.locale !== 'jp' ? item.nameEn : item.nameJp }}</span>
                                </template>
                                <template #selection="{item}">
                                    <span >{{ $i18n.locale !== 'jp' ? item.nameEn : item.nameJp }}</span>
                                </template>
                            </v-select>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-12">
                        <div class="input-group input-group-sm">
                            <span class="input-group-addon mb-1" style="min-width: 9em;">{{$t('alarmSetting.stationName')}}</span>
                        </div>
                        <div class="input-group-append">
                            <v-select :disabled="!modelSearch.DeviceCode" v-model="modelSearch.StationName"
                                v-on:change="handleChangeStationName()"
                                item-value="value"
                                :items="stationNameList" dense
                                outlined>
                                <template v-slot:[`item`]="{ item }">
                                    <span :key="item.value" :value="item.value">{{ item.label + `(${modelSearch.DeviceCode})` }}</span>
                                </template>
                                <template #selection="{item}">
                                    <span >{{ $i18n.locale !== 'jp' ? item.label : item.label }}</span>
                                </template>
                            </v-select>
                        </div>
                    </div>
                </div>
                <div class="row m-1">
                    <div class="col-xl-6 col-lg-6 col-12" v-if="isTsDevice || isVPSDevice">
                        <div class="input-group input-group-sm">
                            <span v-if="isTsDevice" class="input-group-addon mb-1" style="min-width: 9em;">{{$t('exportData.stationTs')}}</span>
                            <span v-if="isVPSDevice" class="input-group-addon mb-1" style="min-width: 9em;">{{$t('alarmSetting.VPSStation')}}</span>
                        </div>
                        <div class="input-group-append">
                            <v-select :items="stationList" v-model="modelSearch.StationDevice" @change="handleChangeStation()"
                                    :item-text="($i18n.locale === 'en') ? 'name' : 'nameJp'" item-value="value" dense outlined
                                    :disabled="!modelSearch.StationName">
                            </v-select>
                        </div>
                    </div>
                    <div v-if="isTsDevice" class="col-xl-6 col-lg-6 col-12">
                        <div class="input-group input-group-sm">
                            <span class="input-group-addon mb-1" style="min-width: 9em;">{{$t("exportData.orgNo")}}</span>
                        </div>
                        <div class="input-group-append">
                            <v-select :items="itemOrgNo" v-model="modelSearch.OrgNo" @change="handleChangeOrgNo()"
                                dense :item-text="($i18n.locale === 'en') ? 'orgNameEn' : 'orgName'" item-value="orgNo" outlined>
                            </v-select>
                        </div>
                    </div>
                </div>
                <div class="row m-1">
                    <!-- --- With divce TS or VPS --- -->
                    <div v-if="isTsDevice" class="col-xl-6 col-lg-6 col-12">
                        <div class="input-group input-group-sm">
                            <span class="input-group-addon mb-1" style="min-width: 9em;">{{$t('alarmSetting.properties')}}</span>
                        </div>
                        <div class="input-group-append">
                            <v-select :items="propertiesTsLst" v-model="modelSearch.Properties" :disabled="!modelSearch.OrgNo && modelSearch.OrgNo != 0"
                                :item-text="($i18n.locale === 'en') ? 'nameEn' : 'nameJp'" item-value="value" dense outlined>
                            </v-select>
                        </div>
                    </div>
                    <div v-if="isVPSDevice" class="col-xl-6 col-lg-6 col-12">
                        <div class="input-group input-group-sm">
                            <span class="input-group-addon mb-1" style="min-width: 9em;">{{$t('alarmSetting.properties')}}</span>
                        </div>
                        <div class="input-group-append">
                        <v-select :items="propertiesVpsLst" v-model="modelSearch.Properties"
                            :item-text="($i18n.locale === 'en') ? 'headerEN' : 'headerJP'" item-value="id" dense outlined
                        >
                        </v-select>
                        </div>
                    </div>
                    <div v-if="!isTsDevice && !isVPSDevice" class="col-xl-6 col-lg-6 col-12">
                        <div class="input-group input-group-sm">
                            <span class="input-group-addon mb-1" style="min-width: 9em;">{{$t('alarmSetting.properties')}}</span>
                        </div>
                        <div class="input-group-append">
                        <v-select :items="propertiesSensor" v-model="modelSearch.Properties"
                            :item-text="($i18n.locale === 'en') ? 'nameEn' : 'nameJp'" item-value="dataCode" dense outlined
                            :disabled="!modelSearch.StationName">
                        </v-select>
                        </div>
                    </div>
                    <!-- --- End dive TS or VPS --- -->
                    <div  class="col-xl-6 col-lg-6 col-12">
                        <div class="input-group input-group-sm">
                            <span class="input-group-addon mb-1" style="min-width: 9em;">{{$t("alarmSetting.level")}}</span>
                        </div>
                        <div class="input-group-append">
                            <v-select :items="dataLevel" v-model="modelSearch.Level"
                                dense :item-text="($i18n.locale === 'en') ? 'lableEn' : 'lableJp'" item-value="value" outlined deletable-chips>
                            </v-select>
                        </div>
                    </div>
                </div>
                <div class="row m-1">
                    <div class="col-xl-6 col-lg-6 col-12">
                        <div class="input-group input-group-sm">
                            <span class="input-group-addon mb-1" style="min-width: 9em;">{{$t("alarmSetting.duration")}}</span>
                        </div>
                        <div class="input-group-append input-group-append-ipad">
                            <div class="w-100 d-flex">
                                <div class="" style="width: 48%;">
                                    <div class="row input-date-mg-ip">
                                        <div class="col-xl-12 col-lg-12 col-12">
                                        <v-menu ref="menu" v-model="menuFrom" :close-on-content-click="false"
                                                transition="scale-transition" offset-y min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                            <v-text-field :readonly="true" v-model="fromFormatted"
                                                            append-icon="mdi-calendar" v-bind="attrs" v-on="on" hide-details="auto" outlined
                                                            dense
                                                            @click:append="menuFrom = true"
                                                            @blur="dateFrom = parseDate(fromFormatted)">
                                            </v-text-field>
                                            </template>
                                            <v-date-picker :allowed-dates="disableStartDates" v-model="dateFrom"
                                                        no-title scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="$refs.menu.save(dateFrom); menuFrom = false">
                                                OK
                                            </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                        </div>
                                    </div>
                                </div>
                                <div style="width: 8%;" class="d-lg-flex justify-content-center sign-ipad sign-iphone">
                                    <b class="m-0 mt-1" style="font-size: 20px;">〜</b>
                                </div>
                                <div class="" style="width: 48%;">
                                    <div class="row justify-content-end input-date-mg-ip">
                                        <div class="col-xl-12 col-lg-12 col-12 pl-3 input-end-date">
                                            <v-menu ref="menu" v-model="menuTo" :close-on-content-click="false" transition="scale-transition"
                                                    offset-y min-width="auto">
                                                <template v-slot:activator="{ on, attrs }">
                                                <v-text-field :readonly="true" v-model="toFormatted"
                                                                append-icon="mdi-calendar" v-bind="attrs" v-on="on"
                                                                hide-details="auto"
                                                                outlined dense @click:append="menuTo = true"
                                                                @blur="dateTo = parseDate(toFormatted)">
                                                </v-text-field>
                                                </template>
                                                <v-date-picker :allowed-dates="disableEndDates" v-model="dateTo"
                                                            no-title scrollable>
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" @click="$refs.menu.save(dateTo); menuTo = false">
                                                    OK
                                                </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </v-form>
            
            <div class="d-flex justify-content-end mr-3" style="padding-right: 18px;">
                <v-btn @click="onSearch()" class="bg-success mr-3 font-weight-bold">
                    <v-icon right dark class="mr-1">
                    fas fa-search
                    </v-icon>
                    {{ $t("labels.search") }}
                </v-btn>
                <v-btn class="bg-secondary font-weight-bold" @click.prevent="clearFilter()">
                    <font-awesome-icon style="margin-right: 9px; font-size: 20px;" icon="fa-solid fa-rotate-right"/>
                    {{ $t("labels.clear") }}
                </v-btn>
            </div>
        </div>

        <div class="card-body p-3 m-2">
          <div class="col-sm-12 col-lg-12 table-date text-nowrap" data-app>
                <v-data-table responsive bordered
                            reactive :headers="headers" :items="itemsSettings"
                            item-key="index"
                            :footer-props="{
                                'items-per-page-options': [15, 30, 50],
                                'items-per-page-text': $i18n.locale === 'en' ? 'Rows per page' : '1ページあたりの行数'
                            }"
                            :page="pageNum" :pageCount="pageSize" :options.sync="options" :server-items-length="totalItems"
                            class="elevation-2" mobile-breakpoint="0" hide-default-header fixed-header>
              <template slot="no-data">
                {{ $t("notification.noData") }}
              </template>
              <template #header="{ props: { headers } }">
                    <thead class="v-data-table-header">
                    <tr>
                        <th v-for="header in headers" :key="header.value" class="text-uppercase font-size-iphone" scope="col">
                        {{ $t(header.text) }}
                        </th>
                    </tr>
                    </thead>
                </template>
              <template v-slot:top>
                <v-toolbar flat>
                  <v-spacer></v-spacer>
                  <v-btn class="add-button-container" depressed color="primary" style="background-color: #3d76ad"
                         @click="onExportToFile()">
                    <span class="add-button" style="font-size: 20px">{{ $t("exportData.export") }}</span>
                  </v-btn>
                </v-toolbar>
              </template>
              <template v-slot:[`item.index`]="{ index }">
                {{ index + 1 }}
              </template>
              <template v-slot:[`item.data`]="{ item }">
                <span class="text-left">{{ item.data }} {{ item.unit }}</span>
              </template>
              <template v-slot:[`item.occurrenceTime`]="{ item }">
                <span>{{ commonFormatStrToDate(item.occurrenceTime, 7) }}</span>
              </template>
            </v-data-table>
          </div>
        </div>
      </div>
      <v-overlay :value="loading">
        <v-progress-circular indeterminate size="64" style="color: #3d76ad !important;"></v-progress-circular>
      </v-overlay>
    </div>
  </template>
  
  <script>
  import {mapActions} from "vuex";
  import {
    cookiesGetI18Lang,
    cookiesSetI18Lang,
    getCookiePrivileges,
    getCookieSiteUser,
    setCurrentPageCode
  } from "@/utils/auth";
  import i18nConfig from "@/i18n.lang";
  import _ from 'lodash';
  import {ResponseCode } from "@/constants/constants"
  import { GetListWarningDataByDivice, ExporWarrningDataToFile, GetListWarningDataByStore, GetListWarningDataByStorePaging } from "@/api/bell";
  
  export default {
    name: "AlarmSettings",
    components: {},
    data() {
      return {
        loading: false,
        ERROR_CODE: '',
        index: 0,
        CURRENT_SITE: null,
        currentLocale: this.$i18n.locale,
        deviceList: [],
        deviceTypes: [],
        stationNameList:[],
        stationList:[],
        itemsSettings:[],
        propertiesSensor:[],
        propertiesTsLst:[],
        propertiesVpsLst:[],
        menuFrom: false,
        menuTo: false,
        dateFrom: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        dateTo: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        fromFormatted: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        toFormatted: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        isTsDevice : false,
        isVPSDevice: false,
        frameName: 'alarm_data',
        modelSearch: {
            SiteId: null,
            DeviceCode: null,
            StationName: null,
            StationDevice: null,
            OrgNo: null,
            Level: null,
            DurationStart: null,
            DurationEnd: null,
            Language: null,
            DeviceType: null,
            StationNameInt: null,
            Properties: null,
            DatabaseName: null,
            PageSize: 15,
            PageNumber: 1
        },
        pageNum: 1,
        pageSize: 15,
        totalItems: 0,
        options: {
            itemsPerPage: 15,
            page: 1
        },
        dataLevel: [
            {lableEn: 'Primary threshold', lableJp:'1次管理値', value: 1},
            {lableEn: 'Secondary threshold', lableJp:'2次管理値', value: 2},
            {lableEn: 'Tertiary threshold', lableJp:'3次管理値', value: 3},
        ],
        headers: [
            {text: '#', sortable: false, value: 'index', align: 'center', width: "50"},
            {text: this.$t('alarmSetting.time'), value: 'occurrenceTime', sortable: false, align: 'center', width: '200'},
            {text: this.$t('alarmSetting.device'), sortable: false, value: 'deviceName', align: 'left', width: "150"},
            {text: this.$t('alarmSetting.station'), value: 'siteStationName', sortable: false, align: 'left', width: "150"},
            {text: this.$t('alarmSetting.data'), value: 'dataName', sortable: false, align: 'left', width: '150'},
            {text: this.$t('alarmSetting.level'), sortable: false, value: 'warningLevel', align: 'left', width: "200"},
            {text: this.$t('alarmSetting.value'), value: 'data', sortable: false, align: 'left', width: '100'},
        ],
        // deviceRules: [
        //     (value) => !!value || this.$t("alarmSetting.errorDevice"),
        // ],
        // siteNameRules: [
        //     (value) => !!value || this.$t("alarmSetting.errorStationName"),
        // ],
        // orgRules: [
        //     (value) => !!value || this.$t("alarmSetting.errorOrg"),
        // ],
      }
    },
    computed: {
    },
    created() {
        let now = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
        this.fromFormatted = this.formatDate(now);
        this.toFormatted = this.formatDate(now);
        setCurrentPageCode(this.PAGE_CODE);
        this.CURRENT_SITE = getCookieSiteUser();
    
        const menuAction = getCookiePrivileges();
        if (menuAction !== undefined && menuAction !== null) {
            JSON.parse(menuAction).filter(value => {
            if (value.children !== undefined && value.children.length > 0) {
                value.children.filter(child => {
                (child.code === this.PAGE_CODE) ? this.ACTION = child.action : '';
                })
            } else {
                (value.code === this.PAGE_CODE) ? this.ACTION = value.action : '';
            }
            })
        }
        if (!cookiesGetI18Lang()) {
            cookiesSetI18Lang(this.$i18n.locale)
        }
        this.$refs.form?.resetValidation();
        this.handleInitializeDeviceList();
    },
    updated() {
        if (this.$i18n.locale !== this.currentLocale) {
            this.currentLocale = this.$i18n.locale;
            this.headers = [
                {text: '#', sortable: false, value: 'index', align: 'center', width: "50"},
                {text: this.$t('alarmSetting.time'), value: 'occurrenceTime', sortable: false, align: 'center', width: '200'},
                {text: this.$t('alarmSetting.device'), sortable: false, value: 'deviceName', align: 'left', width: "150"},
                {text: this.$t('alarmSetting.station'), value: 'siteStationName', sortable: false, align: 'left', width: "150"},
                {text: this.$t('alarmSetting.data'), value: 'dataName', sortable: false, align: 'left', width: '150'},
                {text: this.$t('alarmSetting.level'), sortable: false, value: 'warningLevel', align: 'left', width: "200"},
                {text: this.$t('alarmSetting.value'), value: 'data', sortable: false, align: 'left', width: '100'},
            ];
            if(this.itemsSettings.length > 0){
                this.onSearch();
            }
        }
    },
    async beforeMount() {
      // ========================================================== start import ERROR_CODE by language
      // ==============================================================================================
      const currentLang = this.$i18n.locale
      await import(`@/utils/errors/warning/${currentLang}.js` )
        .then((DATA) => {
          this.ERROR_CODE = DATA.ERROR_CODE
        })
        .catch(async () => {
          await import(`@/utils/errors/warning/${currentLang}.js`)
            .then((DATA) => {
              this.ERROR_CODE = DATA.ERROR_CODE
            })
        })
      // ==============================================================================================
      // =========================================================== stop import ERROR_CODE by language
    },
    methods: {
        ...mapActions('warning', {
                getDeviceList: 'getDeviceList',
                getDeviceProperty: 'getDeviceProperty',
                getStation: 'getStation',
            },
        ),
        ...mapActions("station", {
            getCbbStationTSByDevice: "getCbbStationTSByDevice",
            getCbbOrgInfoBySokGr: "getCbbOrgInfoBySokGr",
            getDatabaseByDeviceAndStation: "getDatabaseByDeviceAndStation"
        }),
        ...mapActions("report", {
            exportDataToFile: "exportDataToFile",
            exportDataToFilePDF: "exportDataToFilePDF"
        }),
        ...mapActions("deviceMaster", {
            getVPSInforByDevice: "getVPSInforByDevice",
        }),
        pad2(n) { return n < 10 ? '0' + n : n },
        
        disableStartDates(val) {
            return this.dateTo == null ? true : val <= this.dateTo;
        },

        disableEndDates(val) {
            return this.dateFrom == null ? true : val >= this.dateFrom;
        },

        formatDate(date) {
            if (!date) return null
            const [year, month, day] = date.split('-')
            return `${year}/${month}/${day}`
        },

        parseDate(date) {
            if (!date) return null
            const [year, month, day] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },

        handleInitializeDeviceList() {
            this.getDeviceList(this.CURRENT_SITE).then((response) => {
                if (response.code === 0) {
                    this.deviceList = response.data;
                }
            }).catch(error => {
                if(error.code != undefined){
                    this.commonNotifyVue(this.ERROR_CODE[error.code], 'warning');
                }
            }).finally(() => {})
        },

        handleSelectDevice(value) {
            this.stationList = [];
            this.stationNameList = [];
            this.itemsSettings = [];
            this.handleGetListStation();
            this.modelSearch.StationName = null;
            this.modelSearch.StationDevice = null;
            this.modelSearch.OrgNo = null;
            this.modelSearch.Properties = null;
            this.modelSearch.StationNameInt = null;
            this.modelSearch.DatabaseName = null;
            const deviceType = this.deviceList.find(item => item.code === value)?.type;
            this.modelSearch.DeviceType = deviceType;
            this.isVPSDevice = false;
            this.isTsDevice = false;
            if(deviceType === 1){
                this.isTsDevice = true
            }
            else if(deviceType === 3){
                this.isVPSDevice = true;
                this.handleGetListProperties();
            }
            else{
                this.getDeviceProperty(this.modelSearch.DeviceCode).then((response) => {
                    if (response.code === 0) {
                        this.propertiesSensor = response.data;
                    }
                }).catch(error => {
                    if(error.code != undefined){
                        this.commonNotifyVue(this.ERROR_CODE[error.code], 'warning');
                    }
                }).finally(() => {})
            }
        },

        handleGetListStation() {
            this.getStation({siteId: this.CURRENT_SITE, deviceCode: this.modelSearch.DeviceCode}).then((response) => {
            if (response.code === 0) {
                this.stationNameList = response.data;
            }
            }).catch(error => {
            if(error.code != undefined)
                this.commonNotifyVue(this.ERROR_CODE[error.code], 'warning');
            }).finally(() => {})
        },

        async handleChangeStationName(){
            this.modelSearch.StationDevice = null;
            this.modelSearch.Properties = null;
            this.modelSearch.DatabaseName = null;
            this.modelSearch.OrgNo = null;
            if(this.modelSearch.DeviceType == 3){
                var valueInt =  this.stationNameList.find(x => x.value === this.modelSearch.StationName).valueInt;
                if(valueInt){
                    this.modelSearch.StationNameInt = valueInt;
                }
                this.handleGetCbbStationTS(this.modelSearch.StationName, this.modelSearch.DeviceCode, null);
            }
            if(this.modelSearch.DeviceType == 1){
                let rq = {
                    SiteId: getCookieSiteUser(),
                    StationId: this.modelSearch.StationName,
                    DeviceCode: this.modelSearch.DeviceCode,
                    SokGrTs: 'all'
                }
                await this.getCbbOrgInfoBySokGr(rq).then(response => {
                    if (response.code === 0) {
                        this.itemOrgNo = response.data;
                    } else {
                        this.commonNotifyVue(this.ERROR_CODE[response.code], 'warning');
                    }
                }).catch(err => {
                    if(err.code != undefined){
                        this.commonNotifyVue(this.ERROR_CODE[err.code], 'warning');
                    }  
                });
                this.handleDatabaseNameTS();
                this.handleGetCbbStationTS(this.modelSearch.StationName, this.modelSearch.DeviceCode, null);
            }
        },

        handleDatabaseNameTS(){
            var request = {
                StationId: this.modelSearch.StationName,
                DeviceCode: this.modelSearch.DeviceCode
            }
            this.getDatabaseByDeviceAndStation(request).then((response) => {
                if (response.code === 0 && response.data) {
                    if(response.data.length > 0){
                        this.modelSearch.DatabaseName = response.data[0].databaseName;
                    }
                }
            }).catch(error => {}).finally(() => {})
        },

        handleGetListProperties() {
            this.getVPSInforByDevice(this.modelSearch.DeviceCode).then((response) => {
                if (response.code === 0) {
                    this.propertiesVpsLst = response.data;
                }
                }).catch(error => {
                    if(error.code != undefined)
                        this.commonNotifyVue(this.ERROR_CODE[error.code], 'warning');
            }).finally(() => {})
        },

        handleGetCbbStationTS(stationId, deviceCode, orgNo) {
            this.loading = true;
            let siteID = getCookieSiteUser();
            this.tsStationLst = [];
            this.getCbbStationTSByDevice({DeviceCode: deviceCode, SiteId: siteID, StationId: stationId, OrgNo: orgNo, DeviceType: this.isVPSDevice ? 3 : null})
            .then(response => {
            if (response.code === 0) {
                this.stationList = response.data.map((i, index) => {
                    var dataI = {value: i.id, name: i.stationName, nameJp: i.stationName };
                    return dataI;
                });
                this.stationList.unshift({value: null, name: 'All Points', nameJp: '全測点' })
                this.loading = false;
            } else {
                this.commonNotifyVue(this.ERROR_CODE[response.code], 'warning');
                this.loading = false;
            }
            }).catch(err => {
                if(err.code != undefined){
                    this.commonNotifyVue(this.ERROR_CODE[err.code], 'warning');
                    this.loading = false;
                }
            }).finally(final => {
                this.loading = false;
            });

        },

        handleChangeStation(){
            this.modelSearch.OrgNo  = null;
            this.modelSearch.Properties = null;
            if(this.isTsDevice){
                this.loading = true;
                let rq = {
                    SiteId: getCookieSiteUser(),
                    StationId: this.modelSearch.StationName,
                    DeviceCode: this.modelSearch.DeviceCode,
                    SokGrTs: this.modelSearch.StationDevice ?? 'all'
                }
                this.getCbbOrgInfoBySokGr(rq).then(response => {
                    if (response.code === 0) {
                        this.itemOrgNo = response.data;
                        this.loading = false;
                    } else {
                        this.commonNotifyVue(this.ERROR_CODE[response.code], 'warning');
                        this.loading = false;
                    }
                }).catch(err => {
                    if(err.code != undefined){
                        this.commonNotifyVue(this.ERROR_CODE[err.code], 'warning');
                        this.loading = false;
                    }  
                }).finally(final => {
                    this.loading = false;
                })
            }
        },

        handleChangeOrgNo(){
            this.modelSearch.Properties = null;
            const orgData = this.itemOrgNo?.find(x=>x.orgNo === this.modelSearch.OrgNo)?.orgData;
            this.propertiesTsLst = orgData.map((i, index) => {
                var dataI = {value: i.dataMapping, nameEn: i.headerEn, nameJp: i.headerJp, unit: i.unit, disable: false, icon: null};
                return dataI;
            });
        },

         validateData(){
            if(!this.modelSearch.DeviceCode){
                this.commonNotifyVue(this.$t("alarmSetting.errorDevice"), 'warning');
                return true;
            }
            if(this.modelSearch.DeviceCode && !this.modelSearch.StationName){
                this.commonNotifyVue(this.$t("alarmSetting.errorStationName"), 'warning');
                return true;
            }
            if(this.isTsDevice && (this.modelSearch.OrgNo == null || this.modelSearch.OrgNo == undefined)){
                this.commonNotifyVue(this.$t("alarmSetting.errorOrg"), 'warning');
                return true;
            }
            return false;
        },

        onSearch() {
            // this.$refs.form.validate()
            // if (!this.$refs.form.validate()) {
            //     return;
            // }
            // if(this.validateData()){
            //     return;
            // }
            this.loading = true;
            const {page, itemsPerPage} = this.options;
            this.modelSearch.DurationStart = new Date(this.dateFrom);
            this.modelSearch.DurationEnd = new Date(this.dateTo);
            this.modelSearch.SiteId = this.CURRENT_SITE;
            this.modelSearch.Language = this.$i18n.locale;
            this.modelSearch.PageSize = itemsPerPage;
            this.modelSearch.PageNumber = page;
            // GetListWarningDataByDivice(this.modelSearch)
            // GetListWarningDataByStore(this.modelSearch)
            GetListWarningDataByStorePaging(this.modelSearch)
            .then((response) => {
                if (response.data && response.data.code === ResponseCode.SUCCESS) {
                    this.itemsSettings = response.data.listData;
                    this.totalItems = response.data.totalRecord;
                    this.loading = false;
                } else {
                    this.commonNotifyVue(this.ERROR_CODE[response.code], "warning");
                    this.loading = false;
                }
            })
            .catch((err) => {
            if(err.code != undefined)
                this.commonNotifyVue(this.ERROR_CODE[err.code], "warning");
                this.loading = false;
            })
            .finally((final) => {this.loading = false;});
        },

        async onExportToFile() {
            // this.$refs.form.validate()
            // if (!this.$refs.form.validate()) {
            //     return;
            // }
            // if(this.validateData()){
            //     return;
            // }
            this.loading = true;
            this.modelSearch.DurationStart = new Date(this.dateFrom);
            this.modelSearch.DurationEnd = new Date(this.dateTo);
            this.modelSearch.SiteId = this.CURRENT_SITE;
            this.modelSearch.Language = this.$i18n.locale;
            this.modelSearch.PageSize = 0;
            this.modelSearch.PageNumber = 1;
            ExporWarrningDataToFile(this.modelSearch)
            .then(response => {
                let date = new Date();
                var fileName = this.frameName + "_" + date.getFullYear().toString() + this.pad2(date.getMonth() + 1) + this.pad2( date.getDate()) + this.pad2( date.getHours() ) + this.pad2( date.getMinutes() ) + this.pad2( date.getSeconds() )+ ".csv"
                this.downloadFileCsv(response.data, fileName);
            })
            .catch(err => {
                console.log(err);
                this.loading = false;
            })
            .finally(final => {
                
                this.loading = false;
            });
        },

        downloadFileCsv(response, fileName) {
            const anchor = document.createElement('a');
            anchor.href = URL.createObjectURL(new Blob([response], {type: 'data:text/csv;charset=utf-8'}));
            anchor.target = '_blank';
            anchor.download = fileName;
            anchor.click();
            this.loading = false;
        },

        clearFilter() {
            this.modelSearch = {
                SiteId: null,
                DeviceCode: null,
                StationName: null,
                StationDevice: null,
                OrgNo: null,
                Level: null,
                DurationStart: null,
                DurationEnd: null,
                Language: null,
                DeviceType: null,
                StationNameInt: null,
                Properties: null,
                DatabaseName: null,
            };
            let now = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
            this.fromFormatted = this.formatDate(now);
            this.toFormatted = this.formatDate(now);
            this.dateFrom = now,
            this.dateTo = now,
            this.itemsSettings = [];
        },
    },
    watch: {
        'options.page': {
            handler() {
                this.onSearch();
            },
        },
        'options.itemsPerPage': {
            handler() {
                this.onSearch();
            },
        },
        '$i18n.locale': async function (currentLang) {
            // ========================================================== start import ERROR_CODE by language
            // ==============================================================================================
            await import(`@/utils/errors/warning/${currentLang}.js` )
            .then((DATA) => {
                this.ERROR_CODE = DATA.ERROR_CODE
            })
            .catch(async () => {
                await import(`@/utils/errors/warning/${currentLang}.js`)
                .then((DATA) => {
                    this.ERROR_CODE = DATA.ERROR_CODE
                })
            })
            // ==============================================================================================
            // =========================================================== stop import ERROR_CODE by language
        },
        'dateFrom'(val) {
            this.fromFormatted = this.formatDate(this.dateFrom)
        },
        'dateTo'(val) {
            this.toFormatted = this.formatDate(this.dateTo)
        },
    }
  }
</script>
  
<style lang="scss" scoped>
    .titleType {
        background-color: #3c8dbc;
        height: 40px;
        width: 100%;
        padding-top: 8px;
        padding-bottom: 8px;
        color: white;
        padding-left: 8px;
        border-radius: 6px
    }
    
    .colmd {
        flex: 0 0 auto;
        max-width: 2.333333%;
    }
    
    .col-date {
        flex: 0 0 auto;
        max-width: 46%;
    }
    
    .buttons-search {
        display: flex;
    }
    
    .btn-search {
        margin-right: 10px;
        background-color: #0d6efd !important;
        color: white !important;
    }
    
    .btn-clear {
        background-color: gray !important;
        color: white !important;
    }
    
    .btn-add {
        background-color: #0d6efd !important;
        color: white !important;
    }
    
    .my_border {
        border-left: 5px solid red;
    }
    
    .table-date td {
        border-left: 2px solid #ebebeb !important;
        border-right: 2px solid #ebebeb !important;
    }
    
    
    .custom-select {
        background: none;
        background-color: white;
    }
    
    .color-red {
        color: red;
    }

    .input-group-append-ipad {
        margin-left: -2px;
    }

    .text-danger {
        color: red;
        font-size: 14px;
    }

    @media (max-width: 1180px) {
        .input-group-append-ipad {
            margin-left: -15px;
        }
        .group-ts-config {
            display: grid;
            width: 50%;
        }
    }
    
    @media (max-width: 820px) {
        .input-group-append-ipad {
            margin-left: 0px;
        }
    }

    @media (min-width: 1000px) and (max-width: 1200px) {
        .input-date-mg-ip {
            margin-left: 0px !important;
        }

        .input-end-date {
            padding-left: 6px !important;
        }
    }
  
    @media only screen and (max-width: 540px) and (max-height: 900px) {
        .add-button {
        font-size: 10px !important;
        }
        .patrolLight-button {
        font-size: 8px !important;
        }
        .patrolLight-button-container {
        height: 1.5rem !important;
        }
        .add-button-container {
        height: 1.5rem !important;
        width: 0.5rem !important;
        }
    }
  ::v-deep{
        @media (max-width: 500px) and (max-height: 896px) {
            .v-data-table > .v-data-table__wrapper > table > thead > tr > th{
                font-size: 1rem !important;
                height: 26px;
                padding: 0px 6px !important;
                text-align: center !important; 
                vertical-align: middle; 
            }
            .v-data-table > .v-data-table__wrapper > table > tbody > tr > td{
                font-size: 0.75rem !important;
                height: 27px !important;
                padding: 0px 6px !important;
            }
            .v-data-footer__pagination {
                margin-left: 6.55rem !important;
            }
        }
    
        @media (min-width: 768px) and (max-width: 1366px) {
            .v-data-table > .v-data-table__wrapper > table > thead > tr > th{
                font-size: 0.8rem !important;
                height: 26px;
                padding: 0px 6px !important;
                text-align: center !important; 
                vertical-align: middle; 
            }
            .v-data-table > .v-data-table__wrapper > table > tbody > tr > td{
                font-size: 1.2rem !important;
                height: 27px !important;
                padding: 0px 6px !important;
            }
        }
        @media (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 2) {
            .v-data-table > .v-data-table__wrapper > table > thead > tr > th{
                font-size: 1rem !important;
                height: 52px;
                padding: 0px 6px !important;
                text-align: center !important; 
                vertical-align: middle; 
            }
            .v-data-table > .v-data-table__wrapper > table > tbody > tr > td{
                font-size: 1.5rem !important;
                height: 54px !important;
                padding: 0px 6px !important;
            }
            .sign-ipad {
                margin-left: 2rem !important;
            }
        }
    }
</style>
  